import React from 'react';
import { Button } from '@mui/material';
import { colors, fonts, borderRadius, spacing, shadows } from '../../constants';
import MicrosoftIcon from './MicrosoftIcon';

const MicrosoftLoginButton = ({ onClick }) => {
  return (
    <Button
      fullWidth
      variant="outlined"
      startIcon={<MicrosoftIcon />}
      onClick={onClick}
      sx={{
      mb: spacing.md,
      py: spacing.sm,
      px: spacing.md,
      borderRadius: borderRadius.md,
      borderColor: colors.borderDefault,
      borderWidth: '1.5px',
      backgroundColor: colors.backgroundWhite,
      color: colors.textPrimary,
      textTransform: 'none',
      fontSize: fonts.fontSizeMd,
      fontWeight: fonts.weightMedium,
      minHeight: '44px',
        letterSpacing: '0.01em',
        transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
        boxShadow: shadows.sm,
        '&:hover': {
          borderColor: colors.borderHover,
          backgroundColor: colors.backgroundLight,
          boxShadow: shadows.md,
          transform: 'translateY(-1px)',
        },
        '&:active': {
          transform: 'translateY(0)',
        },
      }}
    >
      Login with Microsoft
    </Button>
  );
};

export default MicrosoftLoginButton;

